import PropTypes from 'prop-types';
import React from 'react';

import pickTotalsTable from '../utils/pickTotalsTable';

const SecondColumn = ({
  confirm,
  ticketTypes,
  promoCode,
  ticketReservation,
  addOns,
  seatsIOSelectedObjects,
  ticketInsurance,
  selectedMembershipProduct,
  widgetType,
  resaleOrderItems
}) => {
  const isCustom = widgetType === 'custom';
  const TotalsComponent = pickTotalsTable(widgetType, resaleOrderItems);

  return (
    <div className="h-100">
      {confirm.compressed_main_event_image_url ? (
        <img
          src={confirm.compressed_main_event_image_url}
          className={`img-fluid rounded mb-3 ${isCustom ? 'cwb-public-event-image' : ''}`}
        />
      ) : null}
      <div className="d-none d-md-block sticky-top">
        <TotalsComponent
          ticketTypes={ticketTypes}
          promoCode={promoCode}
          ticketReservation={ticketReservation}
          addOns={addOns}
          seatsIOSelectedObjects={seatsIOSelectedObjects}
          confirm={confirm}
          ticketInsurance={ticketInsurance}
          selectedMembershipProduct={selectedMembershipProduct}
          resaleOrderItems={resaleOrderItems}
        />
      </div>
    </div>
  );
};

SecondColumn.propTypes = {
  confirm: PropTypes.object.isRequired,
  ticketTypes: PropTypes.array.isRequired,
  promoCode: PropTypes.object,
  ticketReservation: PropTypes.object,
  addOns: PropTypes.array,
  seatsIOSelectedObjects: PropTypes.array,
  ticketInsurance: PropTypes.object,
  selectedMembershipProduct: PropTypes.object,
  widgetType: PropTypes.string,
  resaleOrderItems: PropTypes.array
};

export default SecondColumn;
